import api from './api';

const LicenseService = {
  GetAllLicenses: () => {
    return api
      .get('/Licenses/GetAllLicenses')
      .then(response => response)
      .catch(error => {
        console.error('Service Error - GetAllLicenses:', error);
        throw error;
      });
  },

  GetLicenseById: (licenseId) => {
    if (!licenseId) {
      return Promise.reject(new Error("License ID is required"));
    }

    return api
      .get(`/Licenses/GetLicenseById?license_id=${encodeURIComponent(licenseId)}`)
      .then(response => response)
      .catch(error => {
        console.error('Service Error - GetLicenseById:', error);
        throw error;
      });
  },

  GetAllActiveLicenses: () => {
    return api
      .get('/Licenses/GetAllActiveLicenses')
      .then(response => response)
      .catch(error => {
        console.error('Service Error - GetAllActiveLicenses:', error);
        throw error;
      });
  },

  AddLicense: (data) => {
    if (!data?.business_id || !data?.system_id) {
      return Promise.reject(new Error("Business ID and System ID are required"));
    }

    return api
      .post('/Licenses/AddLicenses', null, {
        params: {
          business_id: data.business_id,
          system_id: data.system_id,
          expiry_date: data.expiry_date,
          subscription_type: data.subscription_type || "",
          max_users: data.max_users || 1,
          issue_date: data.issue_date || new Date().toISOString().split('T')[0]
        }
      })
      .then(response => response)
      .catch(error => {
        console.error('Service Error - AddLicense:', error.response?.data || error.message);
        throw error;
      });
  },

  UpdateLicenseStatus: (licenseId, status) => {
    if (!licenseId || !status) {
      return Promise.reject(new Error("License ID and Status are required"));
    }

    return api
      .post('/Licenses/updateLicensesStatus', null, {
        params: {
          license_id: licenseId,
          status: status
        }
      })
      .then(response => response)
      .catch(error => {
        console.error('Service Error - UpdateLicenseStatus:', error.response?.data || error.message);
        throw error;
      });
  },
  
  // Get Account Balance
  GetAccountBalance: (accountId) => {
    if (!accountId) {
      return Promise.reject(new Error("Account ID is required"));
    }
    
    return api
      .get(`/Licenses/GetAccBalance?account_id=${encodeURIComponent(accountId)}`)
      .then(response => response)
      .catch(error => {
        console.error('Service Error - GetAccountBalance:', error);
        throw error;
      });
  },
  
  // Get Payment History
  GetPaymentHistory: (licenseId) => {
    if (!licenseId) {
      return Promise.reject(new Error("License ID is required"));
    }
    
    return api
      .get(`/Licenses/GetPaymentHistory?license_id=${encodeURIComponent(licenseId)}`)
      .then(response => response)
      .catch(error => {
        console.error('Service Error - GetPaymentHistory:', error);
        throw error;
      });
  },
  
  // Get Expiring Licenses
  GetExpiringLicenses: (days = 30) => {
    return api
      .get(`/Licenses/GetLicenseExpiring?days=${encodeURIComponent(days)}`)
      .then(response => response)
      .catch(error => {
        console.error('Service Error - GetExpiringLicenses:', error);
        throw error;
      });
  }
};

export default LicenseService;